import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import Articles from '../articlesData';

const ArticleWrapper = ({articleId, children}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const article = Articles.find((a) => a.id === articleId);
    if (!article?.visible) {
      navigate('/in-progress', {replace: true});
    }
  }, [articleId, navigate]);

  return <>{children}</>;
};

export default ArticleWrapper;
